import React, { useState } from "react";
import "./OngoingProjects.css";
import { CSSTransition, SwitchTransition } from "react-transition-group";

const OngoingProjects = () => {
  const projects = [
    {
      id: 1,
      Advertisement: "2",
      title: "Modern Park Evleri",
      subTitle: "Modern Park Evleri",
      images: [
        "https://estate.deltaservis.com.tr/items/3/images/1.jpg",
        "https://estate.deltaservis.com.tr/items/3/images/2.jpg",
        "https://estate.deltaservis.com.tr/items/3/images/3.jpg",
        "https://estate.deltaservis.com.tr/items/3/images/4.jpg",
        "https://estate.deltaservis.com.tr/items/3/images/5.jpg",
        "https://estate.deltaservis.com.tr/items/3/images/6.jpg",
        "https://estate.deltaservis.com.tr/items/3/images/7.jpg",
        "https://estate.deltaservis.com.tr/items/3/images/8.jpg",
        "https://estate.deltaservis.com.tr/items/3/images/9.jpg",
        "https://estate.deltaservis.com.tr/items/3/images/10.jpg",
        "https://estate.deltaservis.com.tr/items/3/images/11.jpg",
        "https://estate.deltaservis.com.tr/items/3/images/12.jpg",
        "https://estate.deltaservis.com.tr/items/3/images/13.jpg",
        "https://estate.deltaservis.com.tr/items/3/images/14.jpg",
        "https://estate.deltaservis.com.tr/items/3/images/15.jpg",
        "https://estate.deltaservis.com.tr/items/3/images/16.jpg",
        "https://estate.deltaservis.com.tr/items/3/images/17.jpg",
        "https://estate.deltaservis.com.tr/items/3/images/18.jpg",
        "https://estate.deltaservis.com.tr/items/3/images/19.jpg",
        "https://estate.deltaservis.com.tr/items/3/images/20.jpg",
        "https://estate.deltaservis.com.tr/items/3/images/21.jpg",
        "https://estate.deltaservis.com.tr/items/3/images/22.jpg",
        "https://estate.deltaservis.com.tr/items/3/images/23.jpg",
        "https://estate.deltaservis.com.tr/items/3/images/24.jpg",
      ],
      features: [
        "Modern mimari çizgilerle tasarlanmış geniş ve ferah yaşam alanları.",
        "Yeşil alanlarla çevrili, parklar ve yürüyüş yolları ile doğayla iç içe bir konum.",
        "Spor salonu, yüzme havuzu ve çocuk oyun alanları gibi sosyal olanaklar.",
        "Farklı yaşam tarzlarına uygun geniş daire seçenekleri ve balkon/teras imkânı.",
        "Şık mutfaklar, modern banyolar ve kaliteli iç mekan tasarımı",
        "Ulaşım kolaylığı sağlayan merkezi bir lokasyonda huzurlu yaşam alanı.",
        "Güvenli site yaşamı ve yüksek yatırım potansiyeli.",
      ],
      description:
        "Doğanın huzurunu modern yaşamla buluşturan Modern Park Evleri, yeşil alanlarla çevrili sakin bir lokasyonda yer alıyor. Modern mimarisi, ferah yaşam alanları ve sosyal donatılarıyla dikkat çeken proje, huzurlu bir yaşam arayanlara konforlu bir seçenek sunuyor. Ulaşım kolaylığı ve yatırım potansiyeli ile de öne çıkan Modern Park Evleri, yeni bir hayatın kapılarını aralıyor.",
    },
    {
      id: 2,
      Advertisement: "3",
      title: "Karacakent Vizyon Sitesi",
      subTitle: "Karacakent Vizyon Sitesi",
      images: [
        "https://estate.deltaservis.com.tr/items/4/images/1.jpg",
        "https://estate.deltaservis.com.tr/items/4/images/2.jpg",
        "https://estate.deltaservis.com.tr/items/4/images/3.jpg",
        "https://estate.deltaservis.com.tr/items/4/images/4.jpg",
        "https://estate.deltaservis.com.tr/items/4/images/5.jpg",
        "https://estate.deltaservis.com.tr/items/4/images/6.jpg",
        "https://estate.deltaservis.com.tr/items/4/images/7.jpg",
        "https://estate.deltaservis.com.tr/items/4/images/8.jpg",
        "https://estate.deltaservis.com.tr/items/4/images/9.jpg",
        "https://estate.deltaservis.com.tr/items/4/images/10.jpg",
        "https://estate.deltaservis.com.tr/items/4/images/11.jpg",
        "https://estate.deltaservis.com.tr/items/4/images/12.jpg",
        "https://estate.deltaservis.com.tr/items/4/images/13.jpg",
        "https://estate.deltaservis.com.tr/items/4/images/14.jpg",
        "https://estate.deltaservis.com.tr/items/4/images/15.jpg",
      ],
      features: [
        "Akıllı ev sistemleri ile elektrik, su, klima ve ısıtma sistemleri uzaktan kontrol edilebiliyor.",
        "Her daireye özel klima altyapısı bulunuyor ve bir adet klima hediye ediliyor.",
        "Merkezi sistem pay ölçerli yerden ısıtma sistemi sağlanıyor.",
        "Spor salonu, sauna ve hamam gibi sosyal donatılar sunuluyor.",
        "Her daire için 1 araçlık kapalı otopark hakkı tanınıyor.",
        "Çocuk oyun alanları ve geniş yeşil alanlar bulunuyor.",
        "Sahil, marina, eğitim kurumları, sağlık tesisleri ve ulaşım noktalarına yakın merkezi bir konumda yer alıyor.",
      ],
      description:
        "Tuzla Postane Mahallesi’nde yer alan Vizyon Sitesi, modern yaşamın ihtiyaçlarını karşılayan mimari tasarımı, geniş sosyal olanakları ve merkezi konumuyla seçkin bir yaşam sunuyor. Konut ve ticari alanları bir arada bulunduran proje, güvenli ve konforlu bir yaşam arayanlar için ideal bir tercih olarak öne çıkıyor.",
    },
  ];

  const [selectedProject, setSelectedProject] = useState(projects[0]);
  const [mainImage, setMainImage] = useState(selectedProject.images[0]);

  const handleThumbnailClick = (image) => {
    setMainImage(image);
  };

  return (
    <div className="devam-eden-projeler container my-5">
      <h2 className="featured-title">Devam Eden Projeler</h2>
      <p className="featured-description">
        Modern mimari ve doğanın uyumunu keşfedin. Huzur, konfor ve yüksek yaşam
        standartlarıyla, estetik tasarımların buluştuğu projelerle geleceğe
        bugünden yatırım yapın.
      </p>
      <div className="project-buttons">
        {projects.map((project) => (
          <button
            key={project.id}
            className={`project-button ${
              selectedProject.id === project.id ? "active" : ""
            }`}
            onClick={() => {
              setSelectedProject(project);
              setMainImage(project.images[0]);
            }}
          >
            {project.title}
          </button>
        ))}
      </div>
      <div className="row mt-4">
        <div className="col-md-6 project-images">
          <SwitchTransition>
            <CSSTransition key={mainImage} timeout={300} classNames="fade">
              <div className="main-image">
                <img src={mainImage} alt="Main Project" />
              </div>
            </CSSTransition>
          </SwitchTransition>
          <div className="thumbnail-images">
            {selectedProject.images.map((image, index) => (
              <img
                key={index}
                src={image}
                alt={`Thumbnail ${index + 1}`}
                onClick={() => handleThumbnailClick(image)}
                className={mainImage === image ? "active-thumbnail" : ""}
              />
            ))}
          </div>
        </div>
        <div className="col-md-6 project-description">
          <h4>{selectedProject.subTitle}</h4>
          <p>{selectedProject.description}</p>
          <ul>
            {selectedProject.features.map((feature, index) => (
              <li key={index}>{feature}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default OngoingProjects;
